angular.module('mean.accounting').controller('workInProgressController', ['$scope', '$http', '$q', 'ngDialog', '$timeout', 'MeanUser', 'toaster', '$filter', 'accountingConstant', 'userService', 'Trades', 'tradeCodeService', 'Projects', 'TradeDrawService', 'Estimates', 'TradeInvoices', 'Extras', 'ProjectHours', 'ProjectMaterials', 'ProjectEquipments', 'ProjectTasks', 'ProjectBids', 'Options', 'costTotalService', 'projectBidService',
    function($scope, $http, $q, ngDialog, $timeout, MeanUser, toaster, $filter, accountingConstant, userService, Trades, tradeCodeService, Projects, TradeDrawService, Estimates, TradeInvoices, Extras, ProjectHours, ProjectMaterials, ProjectEquipments, ProjectTasks, ProjectBids, Options, costTotalService, projectBidService) {
        var vm = this;
        vm.scope = $scope;
        vm.user = MeanUser.user;
        vm.headerConst = accountingConstant.workInProgressHeader;
        $scope.bid_revisions = 1;
        $scope.companyName = '';
        var t0;
        var workInProgressUrl = '/api/workinprogress';
        vm.trade_code = tradeCodeService.getCode(vm.user.trade[0]);
        $scope.selectByGroupModel = [];
        var allProjectData = [];
        var allProjectDataCal = [];
        vm.showSpinner = true;
        $scope.setting2 = {
            scrollableHeight: '200px',
            scrollable: true,
            enableSearch: true,
            showCheckAll: false,
            showUncheckAll: false,
            closeOnSelect: true,
            closeOnDeselect: true,
            groupBy: 'builder',
        };
        $scope.projectText = {buttonDefaultText: 'Select Projects'};
        $scope.setting1 = {
            scrollableHeight: '200px', 
            scrollable: true,
            enableSearch: true,
            showCheckAll: true,
            showUncheckAll: true 
        }
        $scope.builderText = {buttonDefaultText: 'Select Builders'};
        userService.getMainAccount(vm.user.username).then(function(main_account) {
            vm.main_account = main_account;
            vm.company_code = main_account.contractor_code;
            Trades.query({'main_account_id': vm.main_account._id}, function(trade) {
                vm.my_trade = trade[0];
                Extras.query({'trade_id': vm.my_trade._id,'trade': vm.user.trade[0],'type': 'TradeDontPopulate' }, function(extras){
                    vm.trade_extras = extras;
                    vm.username = userService.getMainUsername(vm.user.username);
                    TradeInvoices.query({'trade_code': vm.trade_code, 
                    'company_code': vm.user.contractor_code}, function(invoices) {
                        vm.company_invoices = invoices;
                        var projectData = [];
                        Projects.query({'all_my_projects': true, 
                        'complete': false,
                        'username': userService.getMainUsername(vm.user.username)}, function(projects) {
                            $scope.projects = projects;
                            $scope.builderModel = [];
                            $scope.builderData = _.chain(projects)
                                            .groupBy('builder.name')
                                            .map((value, key) => ({ label: key, id: value }))
                                            .value()
                            
                            $scope.builderTexts = {
                                buttonDefaultText: 'Select Builders',
                            }
                            vm.showSpinner = false;
                        })
                    })
                })
            });
        });

        userService.getCompanyName($scope.user.username).then(function(company) {
            $scope.companyName = company;
        });

        $scope.builderEvents = {
            onSelectionChanged: function() {                
                $timeout(function(){
                    $scope.projectsData = []
                    $scope.projectsModel = [];
                    vm.data = [];
                    allProjectData = [];
                    allProjectDataCal = [];
                    if ($scope.builderModel.length) {
                        $scope.builderModel.map(function(item) {
                            $scope.projectsData = $scope.projectsData.concat(item.id)

                        })
                        $scope.projectsData = $scope.projectsData.map(function(data) {
                            return { id: data, label: data.name, builder: data.builder.name };
                        })
                        $scope.projectsData = _.sortBy($scope.projectsData, ({label}) => label.toLowerCase());
                        $scope.projectsData = _.sortBy($scope.projectsData, ({builder}) => builder.toLowerCase());
                        
                        $scope.projectsTexts = {
                            buttonDefaultText: 'Select Projects',
                        }
                    }
                },0)
            }
        };

        $scope.projectsEvents = {
            onItemSelect: function(item) {
                $timeout(function(){
                    $scope.projectDisable = true;
                    $http.get(workInProgressUrl + '?project=' + item.id._id + '&trade=' +vm.user.trade[0]+ '&tradeId=' + vm.my_trade._id)
                    .success(function(data){
                        var projectdata = { ...item.id, ...data };
                        allProjectData.push(projectdata);
                        var projWithCal = getProjectData(projectdata);
                        allProjectDataCal.push(projWithCal);
                        $timeout(function(){
                            builderCal(allProjectDataCal);
                        },0)
                    })
                    .error(function (data, status) {
                        toaster.pop('error', status, data)
                    });

                }, 0)
            },
            onItemDeselect: function(item) {
                $timeout(function(){
                    if (allProjectData.length) {
                        allProjectData = _.remove(allProjectData, function(proj) {
                            return proj._id !== item.id._id;
                        });
                    }
                    if (allProjectDataCal.length) {
                        allProjectDataCal = _.remove(allProjectDataCal, function(proj) {
                            return proj.id !== item.id._id;
                        });
                        builderCal(allProjectDataCal)
                    }
                },0)
            }
        };
        
        function builderCal (project) {
            vm.data = [];
            vm.projects = project
            vm.project_errors = [];

                var builder_list = [];
                _.each(vm.projects, function(proj) {
                    var builder_idx = -1;
                    //the owner of at project could be the trade and there
                    //is no builder as part of the system.  Here is where we
                    //will build the list by builder.
                    for (var i=0; i < builder_list.length; i++) {
                        if(builder_list[i].name === proj.bname) {
                            builder_idx = i;
                            break;
                        }
                    }

                    if (builder_idx === -1) {
                        vm.data.push({
                            'name' : proj.bname,
                            'type': 'builder',
                            'total' : 0,
                            'projCost': 0,
                            'projCostPercent': 0,
                            'projGrossProfit': 0,
                            'projGrossProfitPercent': 0,
                            'actualCosts': 0,
                            'completionPercent' : 0,
                            'profitToDate': 0,
                            'amountEarned': 0,
                            'totalInvoices': 0,
                            'overBillings': 0,
                            'underBillings': 0,
                            children: []
                        });

                        builder_list.push({
                            name: proj.bname
                        });

                        builder_idx = vm.data.length - 1;
                    }

                    vm.data[builder_idx].children.push(proj);

                    var current_idx = vm.data[builder_idx].children.length-1;
                    vm.data[builder_idx].total +=
                        vm.data[builder_idx].children[current_idx].total;
                    vm.data[builder_idx].actualCosts +=
                        vm.data[builder_idx].children[current_idx].actualCosts;
                    vm.data[builder_idx].projCost +=
                        vm.data[builder_idx].children[current_idx].projCost;
                    vm.data[builder_idx].totalInvoices +=
                        vm.data[builder_idx].children[current_idx].totalInvoices;
                })

            if (vm.project_errors.length !== 0) {
                var project_string = '';
                _.each(vm.project_errors, function(proj, idx) {
                    project_string += proj;

                    if(idx < vm.project_errors.length-1) {
                        project_string += ', '
                    }
                });

                toaster.pop({
                    'type': 'error', 
                    'body': 'proj-error-msg',
                    'bodyOutputType': 'directive',
                    'directiveData': { projects: project_string },
                    'timeout': 0,
                    'showCloseButton': true
                });
            }
            vm.data.map(function(item) {
                var builderTotal = item.total,
                    builderProjCost = item.projCost,
                    builderActualCosts = item.actualCosts,
                    builderInvoices = item.totalInvoices,
                    builderProjGrossProfit = builderTotal - builderProjCost,
                    builderCompletionPercent = calculatePercetage(builderActualCosts, builderProjCost),
                    builderAmountEarned = builderTotal * builderCompletionPercent;
                    builderAmountEarned = builderAmountEarned > builderTotal ? builderTotal : builderAmountEarned;
                var builderOverBillings = builderInvoices - builderAmountEarned,
                    builderUnderBillings = builderAmountEarned - builderInvoices;
                item.projCostPercent = calculatePercetage(builderProjCost, builderTotal) * 100;
                item.projGrossProfit = builderProjGrossProfit;
                item.projGrossProfitPercent = calculatePercetage(builderProjGrossProfit, builderTotal) * 100;
                item.completionPercent = builderCompletionPercent * 100;
                item.profitToDate = builderAmountEarned - builderActualCosts;
                item.amountEarned = builderAmountEarned;
                item.overBillings = builderOverBillings;
                item.underBillings = builderUnderBillings;
            })
        }

        function getProjectData(proj) {
            vm.project_errors = [];
            $scope.trades = [];
            $scope.trades.push({
                name: 'All'
            });

            proj.trades.forEach(function(trade) {
                $scope.trades.push({
                    name: trade.name
                });
            });
            var lots = $filter('unique')(proj.lots, 'phase');
            var phases = [];
            _.each(lots, function(lot) {
                phases.push(lot.phase);
            });

            var project_invoice = $filter('filter')(vm.company_invoices, {
                'job_code': proj.job_code }, true)[0];
            var invoice_amount = 0;
            if(project_invoice) {
                _.each(project_invoice.invoices, function(inv) {
                    invoice_amount += Number(inv.amount);
                });
            }
            vm.project = {
                'id': proj._id,
                'name' : proj.name,
                'bname': proj.builder.name,
                'type': 'project',
                'total' : 0,
                'projCost': 0,
                'projCostPercent': 0,
                'projGrossProfit': 0,
                'projGrossProfitPercent': 0,
                'actualCosts': 0,
                'completionPercent' : 0,
                'profitToDate': 0,
                'amountEarned': 0,
                'totalInvoices': invoice_amount,
                'overBillings': 0,
                'underBillings': 0,
                children: []
            };
            var phase_total = 0;
            var phaseActualCosts = 0;
            var phaseProjCost = 0;
            _.each(phases, function(phase) {
                //contract totals should be contained with the proj.plan_codes data
                //but we need to determine lot reivision as well
                var job_total = 0;
                var actualCosts = 0;
                var projCost = 0;
                var option_total = 0;
                var extra_total = 0;
                var billed = 0;
                var invoices = null;

                var project_invoice = $filter('filter')(vm.company_invoices, {
                    'job_code': proj.job_code }, true)[0];

                if (project_invoice) {
                    var invoices = $filter('filter')(project_invoice.invoices, {
                        'phase': phase}, true);
                    if (invoices) {
                        _.each(invoices, function(i) {
                            billed += Number(i.amount);
                        });
                    }
                }
                // job_total = getJobCostTotal(proj, phase);
                var costDetails = getJobCostActualCost(proj, phase);
                job_total = costDetails && !!costDetails.actual_costs ? costDetails.revenue : 0;
                actualCosts = costDetails && !!costDetails.actual_costs ? costDetails.actual_costs : 0;
                projCost = costDetails && !!costDetails.bid_total_amount ? costDetails.bid_total_amount : 0;
                var projGrossProfit = job_total - projCost;
                var completionPercent = calculatePercetage(actualCosts, projCost);
                var amountEarned = job_total * completionPercent;
                amountEarned = amountEarned > job_total ? job_total : amountEarned;
                vm.project.children.push({
                    'name' : proj.name + ' - ' + phase,
                    'type': 'phase',
                    'phase': phase,
                    'plans': proj.plan_codes,
                    'total' : job_total,
                    'projCost': projCost,
                    'projCostPercent': calculatePercetage(projCost, job_total) * 100,
                    'projGrossProfit': projGrossProfit,
                    'projGrossProfitPercent': calculatePercetage(projGrossProfit, job_total) * 100,
                    'actualCosts': actualCosts,
                    'completionPercent' : completionPercent * 100,
                    'profitToDate': amountEarned - actualCosts,
                    'amountEarned': amountEarned,
                    'totalInvoices': billed,
                    'overBillings': billed - amountEarned,
                    'underBillings': amountEarned - billed,
                });
                phase_total += job_total + option_total + extra_total;
                phaseActualCosts += actualCosts;
                phaseProjCost += projCost;
            });
            var phaseProjGrossProfit = phase_total - phaseProjCost,
                phaseCompletionPercent = calculatePercetage(phaseActualCosts, phaseProjCost),
                phaseAmountEarned = phase_total * phaseCompletionPercent;
                phaseAmountEarned = phaseAmountEarned > phase_total ? phase_total : phaseAmountEarned;
            var phaseOverBillings = invoice_amount - phaseAmountEarned,
                phaseUnderBillings = phaseAmountEarned - invoice_amount;
            vm.project.total = phase_total;
            vm.project.actualCosts = phaseActualCosts;
            vm.project.projCost = phaseProjCost;
            vm.project.projCostPercent = calculatePercetage(phaseProjCost, phase_total) * 100;
            vm.project.projGrossProfit = phaseProjGrossProfit;
            vm.project.projGrossProfitPercent = calculatePercetage(phaseProjGrossProfit, phase_total) * 100;
            vm.project.completionPercent = phaseCompletionPercent * 100;
            vm.project.profitToDate = phaseAmountEarned - phaseActualCosts;
            vm.project.amountEarned = phaseAmountEarned;
            vm.project.overBillings = phaseOverBillings;
            vm.project.underBillings = phaseUnderBillings;
            vm.showSpinner = false;
            $scope.projectDisable = true;
            return vm.project;
        };

        /**
         * @description get Actual cost and bid total
         * @param {object} project
         * @param {String} phase
         */
        function getJobCostActualCost(project, phase) {
            var project = angular.copy(project),
                phase = angular.copy(phase),
                my_extras = angular.copy(project.extras),
                my_tasks = angular.copy(project.tasks),
                bidCopy = angular.copy(project.bids),
                jobCostingLots = $filter('filter')(project.lots, {
                    'phase': phase}, true);
                my_extras = $filter('filter')(my_extras, {
                    'phase': phase}, true);
                my_tasks = $filter('filter')(my_tasks, {
                    'phase': phase}, true),
            _.each(project.task_materials, function(report) {
                report.invoice_date = moment(report.invoice_date).format('MMM D, YYYY');
            });

            var today = moment(),
                bid_rev = $filter('unique')(project.bids, 'revision');
            $scope.bid_revisions = bid_rev.length;
            var latest_bids = $filter('filter')(project.bids, {'latest': true}, true);
            if(latest_bids.length === 0) {
                toaster.pop('error', 'Project Bids Revision Error',
                    'Project Bids have a revision issue. To correct please go to Bid Control Center.  Click the Review button.  In the review mode, click the Regenerate button to refresh the bids associated with this project.');
                return;
            } else {
                $scope.projectBids = project.bids;
            }
            $scope.factors = {};
            var projectTasks = my_tasks.map(function(task) {
                var task_hours = $filter('filter')(project.task_hours, {
                    'project_task_id': task._id}, true);
                var task_materials = $filter('filter')(project.task_materials,
                            { 'phase': task.phase , 'task_code': task.task_code}, true);
                var task_equipment = $filter('filter')(project.task_equipments,
                            { 'phase': task.phase , 'task_code': task.task_code}, true);
                task.actual_material_costs = 0;
                task.actual_equipment_costs = 0;
                _.each(task_materials, function(material) {
                    if(!moment(material.invoice_date).isAfter(today)) {
                        var mat = $filter('filter')(material.materials, {
                            'lot': task.lot}, true);
                        _.each(mat, function(curr_mat) {
                        task.actual_material_costs += Number(curr_mat.total);
                        });
                    }
                });

                _.each(task_equipment, function(equipment) {
                    if(!moment(equipment.invoice_date).isAfter(today)) {
                        var eq = $filter('filter')(equipment.equipment, {'lot': task.lot}, true);
                        //eq.forEach(function(curr_eq) {
                        _.each(eq, function(curr_eq) {
                        task.actual_equipment_costs += Number(curr_eq.total);
                        });
                    }
                });

                var proj_trade = $filter('filter')(project.trades,{
                    'name': task.trade }, true);

                if (proj_trade.length !== 1) {
                    toaster.pop('error', 'workInProgress, line 423',
                        'Could not get the trade to the associated task.  Contact admin.');
                }
                var factors = {};
                factors = proj_trade[0].company_factors;
                $scope.factors = factors;

                task.actual_man_hours = 0;
                task.actual_labor_costs = 0;
                task.actual_workers_comp = 0;

                _.each(task_hours, function(hours) {
                    var work_comp = costTotalService.getWorkersComp(hours, factors)
                    task.actual_workers_comp += !!work_comp ? Number(work_comp): 0;
                    task.actual_man_hours += Number(hours.hours);
                    task.actual_labor_costs += Number(hours.pay_total);
                });
                return task;
            });
            var projectTasksCopy = angular.copy(projectTasks);
            var costDetails = calculateCosting( project, phase, jobCostingLots, projectTasksCopy, my_extras, $scope.factors, bidCopy);
            return costDetails;
        }

        /**
         * @description get cost details of project phase
         * @param {object} project
         * @param {String} phase
         * @param {object} projectTasks
         * @param {object} extras
         * @param {object} projectBids
         * @param {object} factors
         */
        function calculateCosting (project, phase, jobCostingLots, projectTasks, extras, factors, bidCopy) {
            var costDetails = {},
                project = angular.copy(project),
                phase = angular.copy(phase),
                my_extras = angular.copy(extras),
                my_tasks = angular.copy(projectTasks),
                jobCostingLots =  angular.copy(jobCostingLots),
                revision = 1;
                factors = factors;
                costDetails.revenue = 0;
            $scope.all_bid_tasks = [];
            //build contract totals per lot
            var contractTotal = 0,
                optionsTotal = 0,
                extrasTotal = 0,
                lot_numbers = $filter('orderBy')(jobCostingLots, ['number'], false);
            _.each(lot_numbers, function(lot) {
                lot.extras = [];
                var option_lot = $filter('filter')(project.lots, {
                    'phase': phase.name, 'number': lot.name }, true)[0];

                lot.extras = $filter('filter')(my_extras, {
                    'phase': lot.phase, 'lot': lot.number});
                lot.extras_total = 0;
                // var extraMaterial = 0

                _.each(lot.extras, function(extra) {
                    lot.extras_total += Number(extra.total);
                    extrasTotal += Number(extra.total);
                    // extraMaterial += each.material;

                });

                lot.contract_total = 0;

                //check if this lot has revisions applied by a trade.
                if(lot.revisions) {
                    var my_rev = $filter('filter')(lot.revisions, {
                        'trade': vm.user.trade[0]}, true)[0];
                    //don't assume that my trade has a revision
                    if(my_rev) {
                        revision = my_rev.revision;
                    }
                }

                //now that we've identified the lot's trade revision,
                //lets now get the appropriate totals for the plan
                var plan = $filter('filter')(project.plan_codes, {'item': lot.plan}, true);
                if(plan.length === 1) {
                    var trade_total = $filter('filter')(plan[0].trade_totals, {
                        'trade': vm.user.trade[0], 'revision': revision }, true);

                    if(trade_total.length === 1) {
                        lot.contract_total += trade_total[0].total;
                    } else {
                        if(vm.project_errors.indexOf(project.name) === -1)
                            vm.project_errors.push(project.name);
                    }
                } else {
                    toaster.pop('error', 'Problem Finding Plan', 'Could not find plan code ' + 
                        lot.plan + ' in project ' + project.name);
                }

                contractTotal += !!lot.contract_total ?  Number(lot.contract_total) : 0;
                lot.options_total = 0;
                lot.revenue_option_total = 0;

                _.each(lot.active_options, function(active_option) {
                    var cost = $filter('filter')(active_option.totals, {
                        'trade': vm.user.trade[0] }, true)[0];

                    active_option.cost = (cost) ? cost.total : 0;

                    if(!active_option.cost) active_option.cost = 0;
                    lot.options_total += Number(active_option.cost);
                    lot.revenue_option_total += Number(active_option.multiple) * Number(active_option.cost);
                });

                optionsTotal += !!lot.options_total ? Number(lot.options_total) : 0;

                var lot_tasks = $filter('filter')(my_tasks, {'lot': lot.number}, true),
                    ordered_tasks = $filter('orderBy')(lot_tasks, ['job_code'], false);
                    _.each(ordered_tasks, function(task) {
                        var lot_bid_revision = $filter('filter')(option_lot.revisions, {'trade': task.trade}, true);

                        if(lot_bid_revision.length === 1) {
                            lot_bid_revision = lot_bid_revision[0].revision;
                        } else {
                            lot_bid_revision = 1;
                        }

                        var t_m = task.plan_code === 'T&M';
                        //only build the spreadsheets for bid trades
                        var is_tracked = $filter('filter')($scope.trades, {'name': task.trade}, true);
                        if (is_tracked.length === 0) return;

                        // $scope.trades = []
                        var my_bids = [];
                        var t_m = (task.plan_code === 'T&M');
                        if(!t_m) {
    	    				my_bids = $filter('filter')(bidCopy, {
                                'lot': task.lot, 'phase': task.phase, 'task_code': task.task_code }, true);

                            if(my_bids.length === 1) {
                                //this means there is an option applied to this bid task so use it

                            } else {
                                my_bids = $filter('filter')(bidCopy, {
                                    'plan_code': task.plan_code, 'task_code': task.task_code }, true);
        						
                                //remove bids if lot/phase is defined
                                _.remove(my_bids, function(item) {
                                    return item.lot && item.phase;
                                });

                                if(my_bids.length === 0) {
        							var new_bid = {
        								totals: {
        									hours_allowed: 0,
        									labor_cost: 0
        								}
        							}

        							my_bids.push(new_bid);

        						} else if(my_bids.length > 1) {
                                    //this means we have a revision to deal with so lets check what
                                    //revision this lot is set to for the tasks trade.
                                    let lot = $filter('filter')(project.lots, {
                                        'number': task.lot, 'phase': task.phase }, true);
                                    if(lot.length !== 1) {
                                        return;
                                    } else {
                                        let tradeRev = $filter('filter')(lot[0].revisions, {'trade': task.trade}, true);
                                        if(tradeRev.length !== 1) {
                                            return;
                                        } else {
                                            if (tradeRev[0].revision !== $scope.bid_revisions) {
                                                my_bids = $filter('filter')(my_bids, {'revision': tradeRev[0].revision}, true);
                                            } else {
                                                my_bids = $filter('filter')(my_bids, {'latest': true}, true);
                                                if(my_bids.length === 1) {
                                                    my_bids[0].revision = $scope.bid_revisions;
                                                } else {
                                                    return;
                                                }
                                            }
                                            if (my_bids.length !== 1) {
                                                return;
                                            }
                                        }
                                    }
        						}
                            }
                        } else {
                            var new_bid = {
                                totals: {
                                    hours_allowed: 0,
                                    labor_cost: 0
                                }
                            }

                            my_bids.push(new_bid);
                        }
                        var temp_bid = angular.copy(my_bids[0]);
                        temp_bid.lot = task.lot;
                        temp_bid.phase = task.phase;
                        $scope.all_bid_tasks.push(temp_bid);
                        var bid_materials = angular.copy(my_bids[0].materials);
                        task.bid_materials = bid_materials;
                        task.actual_direct_labor = angular.copy(task.actual_labor_costs);
                        var bid_material_cost = 0;
                        _.each(task.bid_materials, function(material) {
                            var sub_tot = material.price_per_order * material.quantity;
                            var cost = sub_tot +
                                (sub_tot * factors.sales_tax) +
                                (material.delivery_price * material.quantity);
                            bid_material_cost += cost;
                        });
                        task.bid_material_cost = bid_material_cost;
                    })
            });
            costDetails.revenue = Number(optionsTotal) + Number(extrasTotal) + Number (contractTotal);

            costDetails.direct_labor = 0;
            costDetails.labor = 0; //dir_lab+taxes+work_comp
            costDetails.materials = 0;
            costDetails.equipment = 0;
            costDetails.general_liability = 0;
            costDetails.total_labor_costs = 0;
            costDetails.actual_costs = 0
            costDetails.bid_total_amount = 0
            _.each(my_tasks, function(task) {
                var extra_labor = 0;
                var total_bids = 0;
                var extra_material = 0;
                var extra_equipment = 0;
                var extras = $filter('filter')(my_extras, {
                    'lot': task.lot, 'phase': task.phase,
                    'task': task.task_code }, true);

                _.each(extras, function(each) {
                    extra_labor += each.labor;
                    extra_material += each.material;
                    extra_equipment += each.equipment;
                });
                
                var t_m = (task.plan_code === 'T&M');
                
                var bid = projectBidService.getProjectBidForTask(
                    task, $scope.all_bid_tasks, project.lots, $scope.bid_revisions);
                if (bid.length !== 1 && !t_m) {
                    return;
                } else {
                    var bid_total = 0;
                    if(!t_m) {
                        bid_total = bid.length && bid[0].totals ? Number(bid[0].totals.labor) + Number(task.bid_material_cost) + 
                        Number(bid[0].totals.equipment) + Number(bid[0].totals.general_liability) : 0;
                    }
                    total_bids += Number(bid_total) + Number(extra_labor) + Number(extra_material) + Number(extra_equipment);
                }
                
                if (!task.hasOwnProperty('actual_material_costs')) {
                    task.actual_material_costs = 0;
                }
                if (!task.hasOwnProperty('actual_equipment_costs')){
                    task.actual_equipment_costs = 0;
                }
                if (!task.hasOwnProperty('actual_labor_costs')) {
                    task.actual_labor_costs = 0;
                }
                if (!task.hasOwnProperty('actual_direct_labor')) {
                    task.actual_direct_labor = 0;
                }
                costDetails.bid_total_amount += Number(total_bids);
                costDetails.direct_labor += Number(task.actual_direct_labor);
                var taxes = 0;
                if (task.actual_direct_labor) {
                    var taxes = task.actual_direct_labor * factors.payroll_taxes;
                    costDetails.workers_comp += !!task.actual_workers_comp ?  Number(task.actual_workers_comp) : 0;
                    costDetails.labor += Number(task.actual_direct_labor) +
                    Number(taxes)+ Number(task.actual_workers_comp);
                }
                costDetails.materials += Number(task.actual_material_costs);
                costDetails.equipment += Number(task.actual_equipment_costs);
            });

            var full_total = Number(contractTotal) +
            Number(optionsTotal) + Number(extrasTotal);
            costDetails.general_liability =
            Number(full_total) * Number(factors.general_liability);
            costDetails.actual_costs = Number(costDetails.labor) + Number(costDetails.materials) +
            Number(costDetails.equipment) + Number(costDetails.general_liability);
            return costDetails;
        };

        /**
         * @description calculate percentage
         * @param {Number} amount
         * @param {Number} totalAmount
         */
        function calculatePercetage (amount, totalAmount) {
            return (amount/totalAmount);
        }

        /**
         * @description itemExpanded
         * @param {object} item
         */
        vm.itemExpanded = function(item) {
            item.expanded = !item.expanded;

            if(item.type === 'builder') {
                //expanding or collapsing at the builder level
                //should reset all projects to collapsed.
                _.each(item.children, function(sub1) {
                    sub1.expanded = false;
                });
            }
        };

        $scope.expandAll = function(expanded) {
            _.each(vm.data, function(item) {
                item.expanded = expanded;
                _.each(item.children, function(sub1) {
                    sub1.expanded = expanded;
                });
            });
        };

        
        $scope.genralWorkingCSV = function(data) {
            var defaultCols = [];
            var str = '';

            // header settings
            _.each(vm.headerConst, function(item, index) {
                defaultCols.push(item.label);
            });
            var str = defaultCols.join(',');
            str += '\r\n';

            // builder list
            _.each(data, function(item) {
                var rowData = [];
                rowData = $scope.getCSVRowData(rowData, vm.headerConst, item);
                str += rowData.join(',');
                str += '\r\n';

                // project list
                _.each(item.children, function(project) {
                    var rowData2 = [];
                    rowData2 = $scope.getCSVRowData(rowData2, vm.headerConst, project);
                    str += rowData2.join(',');
                    str += '\r\n';

                    // Phase list
                    _.each(project.children, function(phase) {
                        var rowData3 = [];
                        rowData3 = $scope.getCSVRowData(rowData3, vm.headerConst, phase);
                        str += rowData3.join(',');
                        str += '\r\n';
                    });
                });
            });

            return str;
        }

        $scope.getCSVRowData = function(dataRow, hederConst, data) {
            _.each(hederConst, function (column) {
                if(column.type == 'perc') {
                    var txtValue = isNaN(data[column.key]) ? 0 : data[column.key].toFixed(2);
                    (Number(txtValue) < 0) ? dataRow.push('') : dataRow.push(txtValue + '%');
                } else if(column.type == 'currency') {
                    var txtValue = isNaN(data[column.key]) ? 0 : data[column.key].toFixed(2);
                    (Number(txtValue) < 0) ? dataRow.push('') : dataRow.push('$' + txtValue);
                } else {
                    dataRow.push(data[column.key])
                }
            });
            
            return dataRow;
        }

        $scope.exportWorkInProgress = function() {

            var dataUrl = 'data:text/csv;utf-8,';
            dataUrl += encodeURI($scope.genralWorkingCSV(vm.data));
            var fileName  = 'work-in-progress.csv';

            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', fileName); 
            link.click();
        };

        $scope.getRowData = function(dataRow, hederConst, data) {
            _.each(hederConst, function (column) {
                if(column.type == 'perc') {
                    var txtValue = isNaN(data[column.key]) ? 0 : data[column.key].toFixed(2);
                    (Number(txtValue) < 0) ? dataRow.push({ text:  '' }) : dataRow.push({ text:  txtValue + '%', bold: true});
                    
                } else if(column.type == 'currency') {
                    var txtValue = isNaN(data[column.key]) ? 0 : data[column.key].toFixed(2);
                    (Number(txtValue) < 0) ? dataRow.push({ text: ''}) : dataRow.push({ text: '$' + txtValue, bold: true});
                    ;
                } else {
                    var styleParam = data.type === 'project' ? [4, 0, 0, 0]
                        : data.type === 'phase' ? [8, 0, 0, 0] : [0, 0, 0, 0];
                        
                    dataRow.push({ text: data[column.key], bold: true, margin: styleParam})
                }
            }); 
            
            return dataRow;
        }

        $scope.workInProgressBody = function (data) {

            var body = []
            var defaultCols = [];

            // header settings
            _.each(vm.headerConst, function(item, index) {
                defaultCols.push({ text: item.label, bold: true });
            });
            body.push(defaultCols); 

            // builder list
            _.each(data, function(item) {
                var rowData = [];
                rowData = $scope.getRowData(rowData, vm.headerConst, item);
                body.push(rowData);

                // project list
                _.each(item.children, function(project) {
                    var rowData2 = [];
                    rowData2 = $scope.getRowData(rowData2, vm.headerConst, project);
                    body.push(rowData2);

                    // Phase list
                    _.each(project.children, function(phase) {
                        var rowData3 = [];
                        rowData3 = $scope.getRowData(rowData3, vm.headerConst, phase);
                        body.push(rowData3); 
                    });
                });
            });
            

            return body;
        }

        $scope.WIPPdfStructure = function(data) {

            var tableBodyData = $scope.workInProgressBody(data);
            return [{
                layout: 'lightHorizontalLines',
                margin: [10, 0, 0, 0], 
                table: {
                    headerRows: 1,
                    widths: [80, 45, 45, 40, 45, 45, 45, 40, 45, 45, 45, 45, 45],
                    body: tableBodyData
                },
                fontSize: 8
            }];
        }

        $scope.buildWIPPDF = function () {

            var tableData , fileName, header_title, sub_header, emailMessage;
            var companyName = $scope.companyName;
            var pageOri = 'landscape';

            sub_header = ' As Of ' + moment().format('MMM DD, YYYY.');

            emailMessage = 'Report on the ' + moment().format('MMM DD, YYYY.');

            header_title = 'Work In Progress Report';
            tableData = $scope.WIPPdfStructure(vm.data);
            fileName  = 'work-in-progress.pdf';

            emailMessage += '<br/><br/>' + header_title;
            emailMessage += '<br/>' + 'Please find your report is attached.<br/><br/>';

            var pdfDataBody = {
                pageMargins: [10, 20, 10, 20],
                pageSize: 'A4',
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-Italic.ttf'
                },
                header: [],
                pageOrientation: pageOri,
                content: [
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: companyName,
                        style: 'company'
                    },
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: header_title,
                        style: 'header'
                    },
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: sub_header,
                        style: 'subHeader'
                    },
                    tableData,
                    ' ',
                    ' '
                ],
                styles: {
                    company: {
                        fontSize: 15,
                        bold: true
                    },
                    header: {
                      fontSize: 12,
                      bold: true
                    },
                    subHeader: {
                        fontSize: 10,
                        bold: true
                    },
                    prjPadding: {
                        bold: true,
                        paddingLeft: 2
                    },
                    phasePadding: {
                        bold: true,
                        paddingLeft: 4
                    },
                    default: {
                        bold: true
                    }
                },
                defaultStyle: {
                    font: 'Roboto'
                }
            }

            if ($scope.just_print) {
                pdfMake.createPdf(pdfDataBody).open();
                $scope.just_print = false;
            } else {

                pdfMake.createPdf(pdfDataBody).getBase64(function (buffer) {
                    var data = ({
                        to: $scope.senderEmail.join(','),
                        from: header_title,
                        subject: header_title,
                        message: emailMessage + 
                                 '<b/><br/>This report is created using A.C.E. Construction Software.<br>' +
                                 'Please do not reply to this email and contact the contractor ' +
                                 'if you have any questions.',
                        fileName: fileName,
                        attachment: buffer
                    });

                    $http.post('/api/sendReports', data).
                        success(function () {
                            toaster.pop('success', 'Message was successfully sent');
                        }).
                        error(function () {
                            toaster.pop('error', 'There was an error with the message');
                    });
                });
            }
        };

        $scope.workingReport = function () {
            $scope.just_print = true;
            $scope.buildWIPPDF();
        }

        $scope.sendWIPEmail = function () {
            $scope.senderEmail = [''];
            ngDialog.openConfirm({
                template: 'accounting/views/reports/modals/emails.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                width: 400
            }).then(function(emails) {
                if(emails.length) {
                    $scope.just_print = false;
                    $scope.buildWIPPDF();
                }
            }, function () {
                $scope.senderEmail = [];
            });
        }

        $scope.addMoreEmails = function () {
            $scope.senderEmail.push('');
        }

        $scope.removeEmails = function (index) {
            $scope.senderEmail.splice(index, 1);
        }
        
    }
]);




// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/workInProgress.js